<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="26"
    height="24"
    viewBox="0 0 16.1 14"
  >
    <g transform="translate(0 0)">
      <g transform="translate(0 0)">
        <path
          class="svg-primary"
          d="M64.373,59.007,63.3,57.93a2.966,2.966,0,0,0,.538-1.713,3.017,3.017,0,1,0-3.017,3.017,3.068,3.068,0,0,0,1.892-.669l1.044,1.044a.433.433,0,0,0,.62,0A.433.433,0,0,0,64.373,59.007Zm-3.556-.62a2.153,2.153,0,1,1,2.153-2.153A2.161,2.161,0,0,1,60.817,58.387Z"
          transform="translate(-48.396 -45.741)"
        />
        <path
          class="svg-primary"
          d="M9.685,18.2H2.929a.926.926,0,0,1-.89-.959V9.62a.926.926,0,0,1,.89-.959H14.678a.926.926,0,0,1,.89.959v3.005a.454.454,0,0,0,.461.448.465.465,0,0,0,.461-.448V9.62a1.86,1.86,0,0,0-1.829-1.87h-3.2V6.823A1.028,1.028,0,0,0,10.443,5.8H6.966A1.028,1.028,0,0,0,5.945,6.823V7.75H2.929A1.86,1.86,0,0,0,1.1,9.62v7.625a1.86,1.86,0,0,0,1.829,1.87H9.7a.454.454,0,0,0,.461-.448A.471.471,0,0,0,9.685,18.2ZM6.884,6.839c0-.064.049-.128.082-.128h3.477c.033,0,.082.048.082.128V7.75H6.884Z"
          transform="translate(-1.1 -5.8)"
        />
      </g>
    </g>
  </svg>
</template>
<script>
export default {};
</script>
